// @ts-ignore
import { DEFAULT_STYLES } from '@Styles/hubDefaultStyles'
import { isEmpty, isNil, mergeWith, path } from 'ramda'
// @ts-ignore
import { result } from '@Helpers/functional'
// @ts-ignore
import { HubTypes } from '@Modules/hubs/constants'

export const mergeThemes = (def: IAppStyles, fromApi: IAppStyles = DEFAULT_STYLES) =>
  mergeWith(themeMerger, def, fromApi)

const themeMerger = (a: any, b: any): boolean => (a !== b && (isEmpty(b) || isNil(b)) ? a : b)

export const SSOProviders = [
  {
    id: 1,
    title: 'Facebook',
    provider: 'facebook',
  },
  {
    id: 2,
    title: 'Google',
    provider: 'google',
  },
  {
    id: 3,
    title: 'LinkedIn',
    provider: 'linkedin',
  },
]

export const getProvider = (provider_id: ID) =>
  SSOProviders.filter(({ id }) => id === provider_id)[0]

export const getProviderString = (provider_id: ID) => getProvider(provider_id).provider

export const canViewAccountSettingsOnHub = (hub: IHub): Object | undefined => {
  return result('user_context.perms.user.manage_user_settings', hub)
}

export const isEmailFormEnabled = (hub: IHub) =>
  hub
    ? !path(['settings', 'auth_options', 'disable_email_form'], hub) &&
      hub.type === HubTypes.SPARQ_MEMBER
    : false
